import { render } from "./pages.vue?vue&type=template&id=351805bb&scoped=true"
import script from "./pages.vue?vue&type=script&lang=js"
export * from "./pages.vue?vue&type=script&lang=js"

import "./pages.vue?vue&type=style&index=0&id=351805bb&lang=less&scoped=true"

import exportComponent from "/Users/shixiaolong/Desktop/code/海玛_EN/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-351805bb"]])

export default __exports__